import { useEffect, useRef, useState } from 'react'
import { type ActiveUser, getActiveUsers, postPresence } from '../services/negotiationsApi'

const HEARTBEAT_INTERVAL = 30_000

export function usePresence(negotiationId: number | null, selfActorId?: string) {
  const [activeUsers, setActiveUsers] = useState<ActiveUser[]>([])
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null)

  useEffect(() => {
    if (negotiationId == null) return

    const tick = async () => {
      try {
        await postPresence(negotiationId, 'viewing')
        const res = await getActiveUsers(negotiationId)
        setActiveUsers(
          selfActorId
            ? res.active_users.filter((u) => u.actor_id !== selfActorId)
            : res.active_users,
        )
      } catch {
        // Silently ignore — presence is best-effort
      }
    }

    void tick()
    intervalRef.current = setInterval(tick, HEARTBEAT_INTERVAL)

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current)
    }
  }, [negotiationId, selfActorId])

  return activeUsers
}
